/***************************************************************************************
 * @module       Service 
 * @name         techus-Service
 * @description  Get the User Authentication Service 
 * @version      1.0.0
 * @license      Licensed under the MIT License
 * @createdon    May 2025
 * @since        1.0
 ***************************************************************************************/

/**
 * Function to register a user via Axios HTTP POST request.
 * @name registerUser
 * @param {object} userData - The user data to be registered.
 * @returns {Promise<object>} - A Promise that resolves with the response data (e.g., success message, user object).
 * @throws {Error} - If an error occurs during the registration process.
 * @version 1.0.0
 */

import Http from '../axois/techus-useAxois';
import { httpClient } from '../axois/SessionHandler';
import ServiceUtils from '../utils/techus-serviceUtils'; // Adjust the import based on your project structure
const utilsService = ServiceUtils();


export const registerUser = async (userData) => {
  try {
    const response = await Http.post('/register', utilsService.prepareAPIRequest(userData));
    return response.data; // Return the response data (e.g., success message, user object)
  } catch (error) {
    throw error; // Handle errors appropriately (e.g., display error messages to the user)
  }
};

export const LoginUser = async (userData = '') => {
  try {
    const response = await Http.post('/login', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const LogOutUser = async (userData = '') => {
  try {
    const response = await Http.get('/logout', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ForgotPassword = async (userData = '') => {
  try {
    const token = localStorage.getItem('user_access_token')
    if (!token) {
      var response = await Http.post('/forget_password', utilsService.prepareAPIRequest(userData));
    }
    else {
      var response = {
        message: 'already_login',
        valid: false
      }
    }
    return response;
  } catch (error) {
    throw error;
  }
};

export const ForgotPasswordTokenCheck = async (userData = '') => {
  try {
    const response = await Http.post('/forget_password_token_check', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const PasswordReset = async (userData = '') => {
  try {

    var response = await Http.post('/password_reset', utilsService.prepareAPIRequest(userData));

    return response;
  } catch (error) {
    throw error;
  }
};

export const UserInfoByToken = async (userData = '') => {
  try {
    const response = await Http.get('/get_user_info_by_token', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ProductNameList = async (userData = '') => {
  try {
    const response = await Http.get('/product_name_list', userData);
    return response;
  } catch (error) {
    throw error;
  }
};


export const GetUserList = async (userData = '') => {
  try {
    const response = await Http.get('/get_user_list', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateUser = async (userData = '') => {
  try {
    const response = await Http.post('/update_user', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const RegisterUser = async (userData = '') => {
  try {
    const response = await Http.post('/register', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const CurrentPasswordChange = async (userData = '') => {
  try {
    const response = await Http.post('/old_password_reset', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAuthLog = async (userData = '') => {
  
  try {
    const response = await Http.get('/authentiocation_log_list', userData);
    return response;
  } catch (error) {
    throw error;
  }
};
export const ListSubmitals = async (userData = '') => {
  try {
    const response = await Http.get('/get_submitals_form', userData);
    return response;
  } catch (error) {
    throw error;
  }
};
export const DeleteUser = async (userData = '') => {
  try {
    const response = await Http.get('/delete_user', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteProject = async (userData = '') => {
  try {
    const response = await Http.get('/delete_project', userData);
    return response;
  } catch (error) {
    throw error;
  }
};


export const GetCity = async (userData = '') => {
  try {
    const response = await Http.post('/get_city', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetState = async (userData = '') => {
  try {
    const response = await Http.post('/get_state', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetContry = async (userData = '') => {
  try {
    const response = await Http.get('/get_country', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const CreateCustomer = async (userData = '') => {
  try {
    const response = await Http.post('/create_customer', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const CreateSubmitalse = async (userData = '') => {
  try {
    const response = await Http.post('/create_submitals', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const ListCustomers = async (userData = '') => { 
  try {
    const response = await Http.get('/list_customers', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteCustomers = async (userData = '') => {
  try {
    const response = await Http.get('/delete_customer', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const CreateProduct = async (userData = '') => {
  try {
    const response = await Http.post('/create_product', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const AddProduct = async (userData = '') => {
  try {
    const response = await Http.post('/product_add', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};
export const DeleteTakeOffProductRow = async (userData = '') => {
  try {
    const response = await Http.post('/product_delete', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};
export const GetCategoryStructure = async (userData = '') => {
  try {
    const response = await Http.get('/get_category_structure', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ListProducts = async (userData = '') => {
  try {
    const response = await Http.get('/list_products', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteProduct = async (userData = '') => {
  try {
    const response = await Http.get('/delete_product', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const CreateProjects = async (userData = '') => {
  try {
    const response = await Http.post('/create_project', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateProjectName = async (userData = '') => {
  try {
    const response = await Http.post('/update_project_name', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const CreateConfigDetails = async (userData = '') => {
  try {
    const response = await Http.post('/create_default_config', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const DefaultConfigDetailsAPI = async (userData = '') => {
  try {
    const response = await Http.get('/config_details', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const CopyPresetAPI = async (userData = '') => {
  try {
    const response = await Http.get('/get_copy_preset', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getLateralPipes = async (userData = '') => {
  try {
    const response = await Http.get('/get_lateral_pipes', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const ProductListExcl = async (userData = '') => {
  try {
    const response = await Http.get('/get_jims_input', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetProjectSummary = async (userData = '') => {
  try {
    const response = await Http.get('/overview_details', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetProjectList = async (userData = '') => {
  
  try {
    const response = await Http.get('/projects_list', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetProjectStatus = async (userData = '') => {
  try {
    const response = await Http.get('/get_wizard', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const UploadPdfAPI = async (userData = '') => {
  try {
    const response = await Http.post('/upload_pdf', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const AddNoteAPI = async (userData = '') => {
  try {
    const response = await Http.post('/add_note', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateLateral = async (userData = '') => {
  try {
    const response = await Http.post('/update_lateral', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteLateralPipe = async (userData = '') => {
  try {
    const response = await Http.post('/delete_lateral_pipe_point', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteLatralTable = async (userData = '') => {
  try {
    const response = await Http.post('/delete_lateral_table', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

// Match the backend's existing five-minute ML request budget.
export const DIAGRAM_REQUEST_TIMEOUT_MS = 300000;
export const GetTwoDdiagram = async (userData = '') => {
  try {
    const response = await httpClient.post('/two_d_diagram_view', utilsService.prepareAPIRequest(userData), { timeout: DIAGRAM_REQUEST_TIMEOUT_MS });
    return response;
  } catch (error) {
    throw error;
  }
};

export const ProjectSubmit = async (userData = '') => {
  try {
    const response = await Http.post('/project_submit', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const pdfExtract = async (userData = '') => {
  try {
    const response = await Http.post('/pdf_extract', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const autoExtract = async (userData = '') => {
  try {
    const response = await Http.post('/auto_detect_structures', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};


export const UnlinkPointAndTakeoffUPAPI = async (userData = '') => {
  try {
    const response = await Http.post('/unlink_point_and_takeoff_up_structure', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteStructureAndPipesAPI = async (userData = '') => {
  try {
    const response = await Http.post('/delete_structure_and_pipes', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const UnlinkPointAndTakeoffDownAPI = async (userData = '') => {
  try {
    const response = await Http.post('/unlink_point_and_takeoff_down_structure', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const contentExtractAPI = async (userData = '') => {
  try {
    const response = await Http.post('/extract_content_structures', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

// Accepts an optional { signal } from an AbortController so the Viewer can
// cancel an in-flight auto-link. Bypasses the Http wrapper because that
// wrapper doesn't expose the axios config slot needed for `signal`.
export const detectAndLinkAPI = async (userData = '', { signal } = {}) => {
  try {
    const config = signal ? { signal } : {};
    const response = await httpClient.post('/detect_and_link', utilsService.prepareAPIRequest(userData), config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const detectSplitsAPI = async (userData = '') => {
  try {
    const response = await Http.post('/detect_splits', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const RecordAutoLinkFeedbackAPI = async (userData = '') => {
  try {
    const response = await Http.post('/record_autolink_feedback', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};



export const GetcontentExtractAPI = async (userData = '') => {
  try {
    const response = await Http.post('/get_extract_content_structures', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};


export const UpdateAnnataionsAPI = async (userData = '') => {
  try {
    const response = await Http.post('/update_annataion_points', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const CreateS3MultipartUpload = async (userData = '') => {
  try {
    const response = await Http.post('/s3_create_multipart_upload', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetPdfPagesCount = async (userData = '') => {
  try {
    const response = await Http.get('/pdf_pages_count', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetS3UploadPartUrls = async (userData = '') => {
  try {
    const response = await Http.post('/s3_upload_part_urls', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const CompleteS3MultipartUpload = async (userData = '') => {
  try {
    const response = await Http.post('/s3_complete_multipart_upload', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const AbortS3MultipartUpload = async (userData = '') => {
  try {
    const response = await Http.post('/s3_abort_multipart_upload', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const ListS3Files = async (userData = '') => {
  try {
    const response = await Http.post('/s3_list_files', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteS3File = async (userData = '') => {
  try {
    const response = await Http.post('/s3_delete_file', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const TriggerExtractStructuresAPI = async (userData = '') => {
  try {
    const response = await Http.post('/trigger_extract_structures', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const ExtractctionContentShowAPI = async (userData = '') => {
  try {
    const response = await Http.post('/extraction_content_show', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};


export const UpdateInPipeAPI = async (userData = '') => {
  try {
    const response = await Http.post('/update_in_pipes', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteTakeOffAPI = async (userData = '') => {
  try {
    const response = await Http.post('/delete_takeoff', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateTakeOff = async (userData = '') => {
  try {
    const response = await Http.post('/update_takeoff', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const AddTakeOffColumnAPI = async (userData = '') => {
  try {
    const response = await Http.post('/add_takeoff_column', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetOutLines = async (userData = '') => {
  try {
    const response = await Http.get('/get_pdf_outlines', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetFiles = async (userData = '') => {
  try {
    const response = await Http.get('/get_files', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetPdfName = async (userData = '') => {
  try {
    const response = await Http.get('/get_pdf_name', userData);
    return response;
  } catch (error) {
    throw error;
  }
};


export const UpdtateAnglePointAPI = async (userData = '') => {
  try {
    const response = await Http.post('/update_angle_points', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdtateAnglePredictAPI = async (userData = '') => {
  try {
    const response = await Http.post('/update_angle_predict', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};



export const UpdtateProductPrice = async (userData = '') => {
  try {
    const response = await Http.post('/update_product_price', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteAnglePredictAPI = async (userData = '') => {
  try {
    const response = await Http.post('/delete_angle_predict', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const DoubleStructureAPI = async (userData = '') => {
  try {
    const response = await Http.post('/convert_double_structure', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const MergeDoubleStructureAPI = async (userData = '') => {
  try {
    const response = await Http.post('/merge_double_structure', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};


export const ProceedTakeOffAPI = async (userData = '') => {
  try {
    const response = await Http.post('/proceed_take_off', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetTakeOffAPI = async (userData = '') => {
  try {
    const response = await Http.post('/get_take_off', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}

export const GetTakeOffStructuresAPI = async (userData = '') => {
  try {
    const response = await Http.post('/get_structure_options_for_take_off', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}
export const SearchStructures = async (userData = '') => {
  try {
    const response = await Http.post('/search_Structures', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}


export const UpdateStructureStatus = async (userData = '') => {
  try {
    const response = await Http.post('/update_structure_view_status', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}

export const UpdateProjectStatus = async (userData = '') => {
  try {
    const response = await Http.post('/update_project_status', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}
export const UpdateProjectAssignee = async (userData = '') => {
  try {
    const response = await Http.post('/update_project_assignee', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}

export const UpdateTakePipe = async (userData = '') => {
  try {
  const response = await Http.post('/update_in_pipe', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}

export const UpdatePipeBootType = async (userData = '') => {
  try {
    const response = await Http.post('/update_pipe_boot_type', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}

export const GetStructureAPI = async (userData = '') => {
  try {
  const response = await Http.post('/view_components', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}

export const GetStructureAPIOrder = async (userData = '') => {
  try {
  const response = await Http.post('/view_components_order', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}
export const GetStructureAPIOrderUpdate = async (userData = '') => {
  try {
  const response = await Http.post('/view_components_update', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
}
 
  export const GetweirsData = async (userData = '') => {
    try {
      const response = await Http.get('/get_weirs', userData);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const GetSubmitalsList = async (userData = '') => {
    try {
      const response = await Http.get('/get_submitals_list', userData);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const ConvertTOCustomer = async (userData = '') => {
    try {
      const response = await Http.post('/convert_to_customer',utilsService.prepareAPIRequest(userData));
      return response;
    } catch (error) {
      throw error;
    }
  };
 
  export const AddWeirsData = async (userData) => {

    try {
      const response = await Http.post('/add_weirs',  utilsService.prepareAPIRequest(userData));
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const GetWeirsDataById = async (userData) => {

    try {
      const response = await Http.post('/get_weirs_by_id',  utilsService.prepareAPIRequest(userData));
      return response;
    } catch (error) {
      throw error;
    }
  };
  
  export const UpdateWeirsData = async (userData) => {

    try {
      const response = await Http.post('/update_weirs',  utilsService.prepareAPIRequest(userData));
      return response;
    } catch (error) {
      throw error;
    }
  };
  export const DeleteWeirsData = async (userData) => { 
    try {
      const response = await Http.post('/delete_weirs',  utilsService.prepareAPIRequest(userData));
      return response;
    } catch (error) {
      throw error;
    }
  };

   
  export const DownloadQoutes = async (userData = '') => {
    try {
      const response = await Http.post('/download_qoute_pdf', utilsService.prepareAPIRequest(userData));
      return response;
    } catch (error) {
      throw error;
    }
  };

export const CreatePresetAPI = async (userData = '') => {
  try {
    const response = await Http.post('/create_preset', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const listPresetAPI = async (userData = '') => {
  try {
    const response = await Http.get('/list_preset', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetEditPresetAPI = async (userData = '') => {
  try {
    const response = await Http.get('/get_edit_preset', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeletePresetAPI = async (userData = '') => {
  try {
    const response = await Http.get('/delete_preset', userData);
    return response;
  } catch (error) {
    throw error;
  }
};
// ***********   calling the projectservises  ***************//

// const fetchProjects = async () => {
//     try {
//       const response = await ProjectService.getProjects();
//       setProjects(response.data);
//     } catch (error) {
//       console.error(error);
//     }
//   };


export const deleteEntireProjects = async (userData = '') => {
  try {
    const response = await Http.get('/delete_entire_projects', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteSubmitals = async (userData = '') => {
  try {
    const response = await Http.post('/delete_submitals', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateTaxPercentage = async (userData = '') => {
  try {
    const response = await Http.post('/update_tax_percentage', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTaxPercentage = async (userData = '') => {
  try {
    const response = await Http.get('/get_tax_percentage',userData);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getUserListOption = async (userData = '') => {
  try {
    const response = await Http.get('/get_user_option',userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GenerateTwoDDiagram = async (userData = '') => {
  try {
    const response = await httpClient.post('/generate_2d_bulk_process', utilsService.prepareAPIRequest(userData), { timeout: DIAGRAM_REQUEST_TIMEOUT_MS });
    return response;
  } catch (error) {
    throw error;
  }
};
export const Submital_path_update = async (userData = '') => {
  try {
    const response = await Http.post('/submital_path_update', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};


export const add_trashtrack_product = async (userData = '') => {
  try {
    const response = await Http.post('/add_trashtrack_product', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const update_trashtrack_product = async (userData = '') => {
  try {
    const response = await Http.post('/update_trashtrack_product', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const list_trashtrack_products = async (userData = '') => {
  try {
    const response = await Http.get('/list_trashtrack_products',userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const delete_trashtrack_product = async (userData = '') => {
  try {
    const response = await Http.post('/delete_trashtrack_product', utilsService.prepareAPIRequest(userData));
    return response;
  } catch (error) {
    throw error;
  }
};
